import {
  QButton,
  QEmptyState,
  QEmptyStateButtonGroup,
  QEmptyStateSecondaryButtonGroup,
} from '@qualio/ui-components';
import { QEmptyStateProps } from '@qualio/ui-components/lib/QComponents/EmptyState/EmptyState';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { changeControlApi } from '../../../../api/changeControl';
import {
  ChangeControlDTO,
  ChangeControlTemplateDTO,
} from '../../../../types/DocumentCreate';
import { DocumentOverviewContext } from '../Context';
import { ChangeControlSelectModal } from './ChangeControlSelectModal';

type ChangeControlEmptyStateProps = {
  onCreated: () => void;
};

export const ChangeControlEmptyState = ({
  onCreated,
}: ChangeControlEmptyStateProps) => {
  const { t } = useTranslation();
  const { qualioDocument } = useContext(DocumentOverviewContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleConfirm = async (
    template: ChangeControlTemplateDTO | undefined,
  ) => {
    setIsModalOpen(false);
    if (template) {
      await changeControlApi.createChangeControl(
        qualioDocument,
        Number(template.id),
        { sections: template.sections } as ChangeControlDTO,
      );
    }
    onCreated();
  };

  const emptyStateProps: QEmptyStateProps = {
    title: t('emptyStates.noChangeControlTemplateSelected'),
    subtitle: t('emptyStates.selectAChangeControlWorkflow'),
  };

  return (
    <>
      <QEmptyState {...emptyStateProps}>
        <QEmptyStateButtonGroup>
          <QEmptyStateSecondaryButtonGroup>
            <QButton
              data-cy="select-cc-template-button"
              variant="outline"
              leftIcon="Plus"
              onClick={() => setIsModalOpen(true)}
            >
              {t('createNewDraft.selectChangeControlTemplate')}
            </QButton>
          </QEmptyStateSecondaryButtonGroup>
        </QEmptyStateButtonGroup>
      </QEmptyState>
      {isModalOpen && (
        <ChangeControlSelectModal
          onClose={() => setIsModalOpen(false)}
          onConfirm={handleConfirm}
          confirmButtonText={t('buttons.createChangeControl')}
        />
      )}
    </>
  );
};
